import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getAllStreams, getUserData } from '../../../api/streams';

import { generateStreamCIDKey } from '../../../components/Streams/utils/generateStreamCIDKey';
import { mergeStreamsListWithUserData } from '../../../utils/streams';
import { REQUEST } from '../../../constants/request';
import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchAllStreams = createAsyncThunk(
  `streams/fetchAllStreams`,
  async ({ params: { count, offset } }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const streamsResponse = await getAllStreams(
        {
          params: {
            count,
            offset,
          },
        },
        {
          cancelToken: source.token,
        },
      );
      const streamsUserDataResponse = { data: {} };

      await Promise.all(
        streamsResponse.data.map(async stream => {
          const { data } = await getUserData({
            path: { orgId: stream.orgId, streamId: stream.id },
          });
          streamsUserDataResponse.data[generateStreamCIDKey(data.streamCID)] =
            data;
        }),
      );

      return mergeStreamsListWithUserData(
        streamsResponse,
        streamsUserDataResponse,
      );
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (_, { getState }) => {
      const streamsStore = getState().streams;

      return (
        streamsStore.streams.allStreams.request?.loading !== REQUEST.pending
      );
    },
  },
);

export const fetchAllStreamsExtraReducers = builder => {
  builder
    .addCase(fetchAllStreams.pending, (state, action) => {
      checkAndSetLoading(state.streams.allStreams.request, action);
    })
    .addCase(fetchAllStreams.fulfilled, (state, action) => {
      onMatchedRequest(state.streams.allStreams.request, action, () => {
        action.payload.streams.forEach(stream => {
          const streamCIDKey = generateStreamCIDKey(stream);

          state.streams.stream.byId[streamCIDKey] = stream;

          if (!state.streams.stream.allIds.includes(streamCIDKey)) {
            state.streams.stream.allIds.push(streamCIDKey);
          }

          state.streams.allStreams.layout.push(streamCIDKey);
        });
      });
    })
    .addCase(fetchAllStreams.rejected, (state, action) => {
      handleRequestRejection(state.streams.allStreams.request, action);
    });
};
